import { render, staticRenderFns } from "./dev-box2.vue?vue&type=template&id=3996c108&scoped=true&"
import script from "./dev-box2.vue?vue&type=script&lang=js&"
export * from "./dev-box2.vue?vue&type=script&lang=js&"
import style0 from "./dev-box2.vue?vue&type=style&index=0&id=3996c108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996c108",
  null
  
)

export default component.exports